import http from '@/services/Http/http'
import { BusinessException, TechnicalException } from '@/services/ErrorHandler'
import axios from 'axios'
export default {
  async requestNewApiKey (packageCode) {
    let params = {
      version: '2.0'
    }
    try {
      let response = await http.Account.post('account/key', { package: packageCode }, { params })
      return response.status === 200
    } catch (e) {
      console.log(e)
      return false
    }
  },
  async deleteApikey (packageKey) {
    let params = {
      version: '3.0'
    }
    try {
      let response = await http.Account.delete(`account/key/${packageKey}`, { params })
      return response.status === 200
    } catch (e) {
      console.log(e)
      return false
    }
  },
  async registerUser (userInfos, token, companyId) {
    let params = {
      version: '3.0'
    }
    try {
      let formdata = {
        firstName: userInfos.firstName,
        lastName: userInfos.lastName,
        password: userInfos.password,
        acceptTerms: userInfos.acceptTerms,
        companyId: companyId,
        registrationToken: token
      }
      let response = await axios.post('account/register', formdata, { params })
      return response.status === 200
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async validateUserEmail (token) {
    let params = {
      version: '2.0'
    }
    try {
      let response = await axios.get(`account/emailVerify/${token}`, { params })
      return response.status === 200
    } catch (e) {
      console.log(e)
      return false
    }
  },
  async accountRegistration (userEmail, countryCode) {
    let params = {
      version: '3'
    }
    try {
      let response = await axios.post(`account/registration`,
        { email: userEmail,
          countryCode: countryCode
        }, { params })
      return response.status === 200
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async retrieveUserTokenInfo () {
    let params = {
      version: '3'
    }
    try {
      let response = await http.Api.get(`account/registration`, { params })
      return response.data
    } catch (error) {
      if (error.response.status === 401) {
        throw new BusinessException('0001', 'Your token has expired')
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async resendUserRegistrationEmail (userEmail) {
    let params = {
      version: '3'
    }
    try {
      let response = await axios.post('account/registration/email/resend', { email: userEmail }, { params })
      return response.data
    } catch (error) {
      throw new TechnicalException(error)
    }
  },
  async getUserAccountInfo () {
    let params = {
      version: '3'
    }
    try {
      let response = await http.Account.get(`account/customer`, { params })
      return response.data
    } catch (error) {
      throw new TechnicalException(error)
    }
  },
  async getPolicySettings () {
    let params = {
      version: '3'
    }
    try {
      let response = await http.Account.get(`account/customer/policySettings`, { params })
      return response.data
    } catch (error) {
      throw new TechnicalException(error)
    }
  }
}
